// Hectare area of a drawn polygon — a client-side mirror of the API's
// GeometryAreaCalculator.ComputeAreaHectares (same spherical-excess formula,
// same WGS84 radius, same 2dp rounding), so a shape's area can be previewed
// before it's saved and still agree with what the server stores.

const EARTH_RADIUS_METRES = 6378137.0;

const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

const ringAreaSquareMetres = (ring: { lat: number; lng: number }[]): number => {
  // leaflet-draw hands back an open ring; the formula wants it closed.
  const first = ring[0];
  const last = ring[ring.length - 1];
  const closed = first && last && (first.lat !== last.lat || first.lng !== last.lng) ? [...ring, first] : ring;
  const n = closed.length;
  if (n < 4) return 0;

  let area = 0;
  for (let i = 0; i < n; i++) {
    let lower: number, middle: number, upper: number;
    if (i === n - 2) { lower = n - 2; middle = n - 1; upper = 0; }
    else if (i === n - 1) { lower = n - 1; middle = 0; upper = 1; }
    else { lower = i; middle = i + 1; upper = i + 2; }
    area += (toRadians(closed[upper].lng) - toRadians(closed[lower].lng)) * Math.sin(toRadians(closed[middle].lat));
  }
  return Math.abs((area * EARTH_RADIUS_METRES * EARTH_RADIUS_METRES) / 2);
};

/** Null for anything but a Polygon (points/lines have no area). */
export const polygonAreaHectares = (shape: { geometryType: string; points: { lat: number; lng: number }[] } | null | undefined): number | null => {
  if (!shape || shape.geometryType !== 'Polygon') return null;
  return Math.round((ringAreaSquareMetres(shape.points) / 10_000) * 100) / 100;
};
